import { frontendURL } from 'dashboard/helper/URLHelper';

const ContractsView = () => import('./ContractsView.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/contracts'),
      component: ContractsView,
      name: 'contracts_index',
      meta: {
        permissions: ['administrator', 'agent'],
      },
    },
  ],
};
